(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('v2-cart-upsell')) {
    const upsellCache = new Map();

    class V2CartUpsell extends HTMLElement {
      static busy = false;

      connectedCallback() {
        this.list = this.querySelector('[data-upsell-list]');
        this.onClick = (event) => {
          const button = event.target.closest('[data-upsell-add]');
          if (button) this.add(button);
        };
        this.addEventListener('click', this.onClick);
        if (this.dataset.url) this.loadRecommendations(this.dataset.url);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      async loadRecommendations(url) {
        try {
          let html = upsellCache.get(url);
          if (html === undefined) {
            const response = await fetch(url);
            if (!response.ok) return;
            html = await response.text();
            upsellCache.set(url, html);
          }
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-upsell-list]');
          if (fresh && fresh.children.length > 0 && this.isConnected) {
            this.list.innerHTML = fresh.innerHTML;
            this.hidden = false;
          }
        } catch (error) {
          // Keep the manually picked products when recommendations cannot be loaded.
        }
      }

      async add(button) {
        const drawer = document.querySelector('cart-drawer');
        if (V2CartUpsell.busy || !drawer) return;
        V2CartUpsell.busy = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.querySelector('.loading__spinner')?.classList.remove('hidden');

        const errors = document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = '';

        const body = new FormData();
        body.append('id', button.dataset.variantId);
        body.append('quantity', '1');
        body.append('sections', drawer.getSectionsToRender().map((section) => section.id));
        body.append('sections_url', window.location.pathname);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = body;

        let added = false;
        try {
          const response = await fetch(routes.cart_add_url, config).then((res) => res.json());
          if (response.status) {
            if (errors) errors.textContent = response.description || response.message || window.cartStrings?.error || '';
          } else {
            added = true;
            drawer.renderContents(response);
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'v2-cart-upsell',
              productVariantId: button.dataset.variantId,
              cartData: response,
            });
          }
        } catch (error) {
          if (errors) errors.textContent = window.cartStrings?.error || '';
        } finally {
          V2CartUpsell.busy = false;
          if (!added && button.isConnected) {
            button.disabled = false;
            button.removeAttribute('aria-busy');
            button.querySelector('.loading__spinner')?.classList.add('hidden');
          }
        }
      }
    }

    customElements.define('v2-cart-upsell', V2CartUpsell);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v2-fixed-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('v2-review-text')) {
    customElements.define(
      'v2-review-text',
      class V2ReviewText extends HTMLElement {
        connectedCallback() {
          this.comment = this.querySelector('[data-review-comment]');
          this.toggle = this.querySelector('[data-review-toggle]');
          if (!this.comment || !this.toggle) return;
          this.toggle.addEventListener('click', () => this.setExpanded(!this.classList.contains('is-expanded')));
          this.observer = new ResizeObserver(() => this.update());
          this.observer.observe(this.comment);
          this.update();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        update() {
          if (this.classList.contains('is-expanded')) return;
          this.toggle.hidden = this.comment.scrollHeight <= this.comment.clientHeight + 1;
        }

        setExpanded(expanded) {
          this.classList.toggle('is-expanded', expanded);
          this.toggle.setAttribute('aria-expanded', String(expanded));
          this.toggle.textContent = expanded ? this.toggle.dataset.less : this.toggle.dataset.more;
          if (!expanded) this.update();
        }
      }
    );
  }

  /* Page dots for the review slider: one dot per screenful of cards; the active dot follows the scroll position. */
  if (!customElements.get('v2-freviews-dots')) {
    customElements.define(
      'v2-freviews-dots',
      class V2FreviewsDots extends HTMLElement {
        connectedCallback() {
          this.track = this.closest('v2-scroller')?.querySelector('[data-scroller-track]');
          if (!this.track) return;
          this.items = [...this.track.children];
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.resizeObserver = new ResizeObserver(this.build);
          this.resizeObserver.observe(this.track);
          this.build();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
          this.track?.removeEventListener('scroll', this.onScroll);
        }

        perView() {
          const first = this.items[0];
          if (!first) return 1;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          return Math.max(1, Math.floor((this.track.clientWidth + gap + 1) / (first.offsetWidth + gap)));
        }

        build = () => {
          const pages = Math.ceil(this.items.length / this.perView());
          if (pages === this.pages) return this.update();
          this.pages = pages;
          this.replaceChildren();
          this.hidden = pages < 2;
          for (let i = 0; i < pages; i++) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'v2-freviews__dot';
            dot.setAttribute('aria-controls', this.track.id);
            dot.setAttribute('aria-label', this.dataset.label.replace('[n]', i + 1).replace('[t]', pages));
            dot.addEventListener('click', () => this.goTo(i));
            this.append(dot);
          }
          this.update();
        };

        goTo(page) {
          const item = this.items[Math.min(page * this.perView(), this.items.length - 1)];
          const max = this.track.scrollWidth - this.track.clientWidth;
          const start = this.items[0].offsetLeft;
          this.track.scrollTo({ left: Math.min(item.offsetLeft - start, max) });
        }

        onScroll = () => {
          window.cancelAnimationFrame(this.frame);
          this.frame = window.requestAnimationFrame(() => this.update());
        };

        update() {
          if (!this.pages) return;
          const max = this.track.scrollWidth - this.track.clientWidth;
          const active = max > 0 ? Math.round((this.track.scrollLeft / max) * (this.pages - 1)) : 0;
          [...this.children].forEach((dot, i) => dot.setAttribute('aria-current', String(i === active)));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v2-product-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('v2-review-text')) {
    customElements.define(
      'v2-review-text',
      class V2ReviewText extends HTMLElement {
        connectedCallback() {
          this.comment = this.querySelector('[data-review-comment]');
          this.toggle = this.querySelector('[data-review-toggle]');
          if (!this.comment || !this.toggle) return;
          this.toggle.addEventListener('click', () => this.setExpanded(!this.classList.contains('is-expanded')));
          this.observer = new ResizeObserver(() => this.update());
          this.observer.observe(this.comment);
          this.update();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        update() {
          if (this.classList.contains('is-expanded')) return;
          this.toggle.hidden = this.comment.scrollHeight <= this.comment.clientHeight + 1;
        }

        setExpanded(expanded) {
          this.classList.toggle('is-expanded', expanded);
          this.toggle.setAttribute('aria-expanded', String(expanded));
          this.toggle.textContent = expanded ? this.toggle.dataset.less : this.toggle.dataset.more;
          if (!expanded) this.update();
        }
      }
    );
  }

  if (!customElements.get('v2-review-gallery')) {
    customElements.define(
      'v2-review-gallery',
      class V2ReviewGallery extends HTMLElement {
        connectedCallback() {
          this.viewer = this.querySelector('[data-review-viewer]');
          this.image = this.querySelector('[data-review-viewer-image]');
          if (!this.viewer || !this.image || typeof this.viewer.showModal !== 'function') return;

          this.addEventListener('click', (event) => {
            const photo = event.target.closest('[data-review-photo]');
            if (photo) this.open(photo);
          });
          this.querySelector('[data-review-viewer-close]')?.addEventListener('click', () => this.viewer.close());
          this.viewer.addEventListener('click', (event) => {
            if (event.target === this.viewer) this.viewer.close();
          });
          this.viewer.addEventListener('close', () => {
            document.documentElement.style.overflow = '';
            this.trigger?.focus();
          });
        }

        open(photo) {
          this.trigger = photo;
          this.image.src = photo.dataset.src;
          this.image.alt = photo.dataset.alt || '';
          this.image.width = Number(photo.dataset.width) || 0;
          this.image.height = Number(photo.dataset.height) || 0;
          document.documentElement.style.overflow = 'hidden';
          this.viewer.showModal();
        }
      }
    );
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#ProductReviews"]');
    const target = link && document.getElementById('ProductReviews');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v2-scroller-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('v2-scroller')) {
    customElements.define(
      'v2-scroller',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-scroller-track]');
          this.prev = this.querySelector('[data-scroller-prev]');
          this.next = this.querySelector('[data-scroller-next]');
          if (!this.track) return;
          this.prev?.addEventListener('click', () => this.scrollByPage(-1));
          this.next?.addEventListener('click', () => this.scrollByPage(1));
          this.track.addEventListener('scroll', this.update, { passive: true });
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.track);
          this.update();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        scrollByPage(direction) {
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          let distance = this.track.clientWidth * 0.9;
          // data-step="item" on the v2-scroller moves one card per click instead of a screenful.
          const first = this.track.firstElementChild;
          if (this.dataset.step === 'item' && first) {
            distance = first.offsetWidth + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
          }
          this.track.scrollBy({ left: direction * distance, behavior: reduce ? 'auto' : 'smooth' });
        }

        update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          this.dataset.overflow = max > 2 ? 'true' : 'false';
          if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
          if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v2-shipping-countdown"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('v2-shipping-countdown')) return;

    const TIME_ZONE = 'Europe/Istanbul';
    const DAY_MS = 86400000;

    // Wall-clock parts of an instant in Istanbul time.
    const zoneFormatter = new Intl.DateTimeFormat('en-US', {
      timeZone: TIME_ZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
    });

    const zonedParts = (ms) => {
      const parts = {};
      zoneFormatter.formatToParts(new Date(ms)).forEach((part) => {
        parts[part.type] = Number(part.value);
      });
      return parts;
    };

    // Calendar days are counted as whole days since 1970-01-01, which keeps day arithmetic free of time zones.
    const dayNumber = (y, m, d) => Math.round(Date.UTC(y, m - 1, d) / DAY_MS);
    const weekday = (day) => new Date(day * DAY_MS).getUTCDay();

    // The UTC instant of a given Istanbul wall-clock time on a calendar day.
    const zonedTimeToMs = (day, minutes) => {
      const guess = day * DAY_MS + minutes * 60000;
      let result = guess;
      for (let i = 0; i < 2; i++) {
        const p = zonedParts(result);
        const shownAsUtc = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
        result = guess - (shownAsUtc - result);
      }
      return result;
    };

    // Accepts one date or a range per line: 2026-10-29, 29.10.2026, 2027-03-19 / 2027-03-22.
    const parseHolidays = (text) => {
      const days = new Set();
      const pattern = /(\d{4})-(\d{1,2})-(\d{1,2})|(\d{1,2})[./](\d{1,2})[./](\d{4})/g;
      String(text || '')
        .split(/[\n,;]+|\s{2,}/)
        .forEach((line) => {
          const found = [...line.matchAll(pattern)].map((m) =>
            m[1] ? dayNumber(+m[1], +m[2], +m[3]) : dayNumber(+m[6], +m[5], +m[4])
          );
          if (found.length === 1) days.add(found[0]);
          if (found.length === 2 && found[1] >= found[0] && found[1] - found[0] <= 60) {
            for (let day = found[0]; day <= found[1]; day++) days.add(day);
          }
        });
      return days;
    };

    /**
     * Works out the order deadline and the shipping day for a moment in time.
     * Orders placed before the cut-off on a shipping day start being prepared that day; later orders, or orders
     * on days off, start on the next shipping day. Preparation then takes `prepDays` further shipping days.
     */
    const compute = (now, config) => {
      const isWorkday = (day) => config.shipDays.has(weekday(day)) && !config.holidays.has(day);
      const nextWorkday = (day) => {
        for (let next = day + 1; next <= day + 120; next++) {
          if (isWorkday(next)) return next;
        }
        return null;
      };

      const p = zonedParts(now);
      const today = dayNumber(p.year, p.month, p.day);
      const secondsNow = p.hour * 3600 + p.minute * 60 + p.second;

      let orderDay = today;
      if (!isWorkday(today) || secondsNow >= config.cutoff * 60) orderDay = nextWorkday(today);
      if (orderDay === null) return null;

      let shipDay = orderDay;
      for (let i = 0; i < config.prepDays; i++) {
        shipDay = nextWorkday(shipDay);
        if (shipDay === null) return null;
      }

      return {
        today,
        orderDay,
        shipDay,
        minutesNow: p.hour * 60 + p.minute,
        deadline: zonedTimeToMs(orderDay, config.cutoff),
        remaining: zonedTimeToMs(orderDay, config.cutoff) - now,
      };
    };

    const formatDuration = (ms, units) => {
      const total = Math.max(1, Math.ceil(ms / 60000));
      const minutes = total % 60;
      // Under two days the countdown stays in hours and minutes so it visibly moves every minute.
      if (total >= 2880) {
        const days = Math.floor(total / 1440);
        const dayHours = Math.floor((total % 1440) / 60);
        return dayHours > 0 ? `${days} ${units.day} ${dayHours} ${units.hour}` : `${days} ${units.day}`;
      }
      const hours = Math.floor(total / 60);
      if (hours > 0) return minutes > 0 ? `${hours} ${units.hour} ${minutes} ${units.minute}` : `${hours} ${units.hour}`;
      return `${minutes} ${units.minute}`;
    };

    const longDate = new Intl.DateTimeFormat('tr-TR', { day: 'numeric', month: 'long', weekday: 'long', timeZone: 'UTC' });
    const weekdayName = new Intl.DateTimeFormat('tr-TR', { weekday: 'long', timeZone: 'UTC' });

    /**
     * The shipping day as words, in Istanbul time:
     * - "bugün" when it ships today and it is already past the morning start (09:00), so only between 09:00 and the cut-off;
     * - "yarın" when it ships the next calendar day;
     * - otherwise the weekday, e.g. "Pazartesi" (also before 09:00 on a shipping day);
     * - the full date, e.g. "28 Ekim Çarşamba", only when shipping is a week or more away.
     * Days off and holidays never show "bugün", because the order then moves to the next shipping day.
     */
    const formatShipDay = (result, labels) => {
      const diff = result.shipDay - result.today;
      if (diff === 0 && result.minutesNow >= labels.todayFrom) return labels.today;
      if (diff === 1) return labels.tomorrow;
      // Within the coming week the weekday alone is clear ("Pazartesi"); further out (long holidays) the date is added.
      if (diff < 7) return weekdayName.format(new Date(result.shipDay * DAY_MS));
      return longDate.format(new Date(result.shipDay * DAY_MS));
    };

    const escapeHtml = (value) =>
      String(value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

    class ShippingCountdown extends HTMLElement {
      connectedCallback() {
        const { cutoff, prepDays, shipDays, holidays } = this.dataset;
        const [hour, minute] = String(cutoff || '').split(':').map(Number);
        const days = String(shipDays || '')
          .split(',')
          .filter((d) => d !== '')
          .map(Number);
        if (!Number.isInteger(hour) || !Number.isInteger(minute) || !/^\d+$/.test(prepDays || '') || days.length === 0) return;

        const [fromHour, fromMinute] = String(this.dataset.todayFrom || '00:00').split(':').map(Number);
        this.labels = {
          today: this.dataset.today,
          tomorrow: this.dataset.tomorrow,
          todayFrom: (fromHour || 0) * 60 + (fromMinute || 0),
        };
        this.config = {
          cutoff: hour * 60 + minute,
          prepDays: Number(prepDays),
          shipDays: new Set(days),
          holidays: parseHolidays(holidays),
        };
        this.textElement = this.querySelector('[data-shipping-text]');
        this.onVisibility = () => {
          if (document.visibilityState === 'visible') this.update();
        };
        document.addEventListener('visibilitychange', this.onVisibility);
        this.update();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      update() {
        clearTimeout(this.timer);
        const now = Date.now();
        const result = compute(now, this.config);
        if (!result || !this.textElement) return;

        const units = { day: this.dataset.unitDay, hour: this.dataset.unitHour, minute: this.dataset.unitMinute };
        // The countdown only shows when today's cut-off is still ahead. After the cut-off, on weekends and on
        // holidays a 20–60 hour countdown is meaningless, so the card just names the shipping day instead.
        const template =
          result.orderDay === result.today ? this.dataset.template : this.dataset.templateLater || this.dataset.template;
        this.textElement.innerHTML = (template || '')
          .replace('[time]', escapeHtml(formatDuration(result.remaining, units)))
          .replace('[day]', escapeHtml(formatShipDay(result, this.labels)));
        this.classList.add('is-live');

        // Refresh on the next minute boundary, or right at the deadline if that comes first, so the text
        // switches by itself at 09:00 and at the cut-off without a page reload.
        const toNextMinute = 60000 - (now % 60000);
        this.timer = setTimeout(() => this.update(), Math.max(1000, Math.min(toNextMinute, result.remaining + 500)));
      }
    }

    customElements.define('v2-shipping-countdown', ShippingCountdown);
    window.AbajuuShippingCountdown = { compute, formatDuration, formatShipDay, parseHolidays, zonedTimeToMs, dayNumber };
  })();
  } catch(e) { console.error(e); }
})();

})();
